export const sanitizeTerraUserId = (terraUserId?: string | null): string => {
  if (!terraUserId) {
    return '';
  }

  return terraUserId.split('#')[0].trim();
};
